import React from "react";

export default function Customer() {
    return (
        <div>
           Customer
        </div>
    )
}